module.exports = __webpack_public_path__ + "img/ios-install-step-1.6a2fd5db.svg";